module.exports = fox._r("images/promo/tutorial/17.png", __webpack_public_path__ + "_/common/images/promo/tutorial/17.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/17.png
// module id = 665
// module chunks = 2